export default function BackgroundFX() {
  return (
    <div className="background-fx" aria-hidden="true">
      <div className="profile-glow profile-glow-mint" />
      <div className="profile-glow profile-glow-violet" />
      <div className="background-grain" />
    </div>
  );
}